module.exports = __webpack_public_path__ + "static/media/Newburgh-Park-By-Laws.dbda82c3.pdf";